import { render } from "./AtencionForm.vue?vue&type=template&id=08770887&scoped=true"
import script from "./AtencionForm.vue?vue&type=script&lang=js"
export * from "./AtencionForm.vue?vue&type=script&lang=js"

import "./AtencionForm.vue?vue&type=style&index=0&id=08770887&scoped=true&lang=css"
import "@/assets/css/alertas.css?vue&type=style&index=1&id=08770887&scoped=true&lang=css"
import "@/assets/css/microfono.css?vue&type=style&index=2&id=08770887&scoped=true&lang=css"
import "@/assets/css/listaRegistros.css?vue&type=style&index=3&id=08770887&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08770887"]])

export default __exports__